import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root:{
    margin:40
  },
  dropdown:{
    float:'right',
    marginRight:45
  },
  toggler:{
    float:'right',
    marginTop:25,
  }
}));